import { useParams } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { ResetPassword } from '../containers/ResetPassword/ResetPassword';
import type { RegionEnum } from '../config/region';

export const ResetPasswordPage = () => {
  const { userId, resetToken, region } = useParams<{
    userId: string;
    resetToken: string;
    region: RegionEnum;
  }>();

  return (
    <Layout isAuthLayout={false}>
      <ResetPassword userId={userId} resetToken={resetToken} region={region} />
    </Layout>
  );
};
